import { render, staticRenderFns } from "./workSideBar.vue?vue&type=template&id=4366ca67&scoped=true&"
import script from "./workSideBar.vue?vue&type=script&lang=js&"
export * from "./workSideBar.vue?vue&type=script&lang=js&"
import style0 from "./workSideBar.vue?vue&type=style&index=0&id=4366ca67&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4366ca67",
  null
  
)

export default component.exports